/* UX-1006 (2026-10-06) — small behaviours for the decluttered product and collection pages.
   1. "Read more" buttons: [data-fmr-readmore][aria-controls] toggles .is-open on the target and flips
      aria-expanded and the label. The text is always in the HTML; CSS only clamps it (phones).
      If the target is not actually clamped at the current width, the button hides itself.
   2. Configurator "N things left" panel ([data-pcfg-missing], app extension): the theme keeps it calm
      (assets/geo-cfg-head.css) and marks it data-fmr-alert after the shopper taps a blocked button
      (Continue / Add to cart while something is missing). The mark goes away when the panel hides. */
(function () {
  'use strict';
  if (window.__fmrDeclutter) return;
  window.__fmrDeclutter = true;

  /* ── 1. Read more ─────────────────────────────────────────────────────── */
  function targetOf(btn) {
    var id = btn.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }
  function label(btn, open) {
    btn.textContent = open ? (btn.getAttribute('data-less') || 'Show less') : (btn.getAttribute('data-more') || 'Read more');
  }
  function syncReadmore() {
    var btns = document.querySelectorAll('[data-fmr-readmore]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i], t = targetOf(b);
      if (!t || t.classList.contains('is-open')) continue;
      if (getComputedStyle(b).display === 'none') continue; /* not clamped at this width (CSS) */
      b.hidden = !(t.scrollHeight > t.clientHeight + 2);
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-fmr-readmore]') : null;
    if (!b) return;
    var t = targetOf(b);
    if (!t) return;
    var open = !t.classList.contains('is-open');
    t.classList.toggle('is-open', open);
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    label(b, open);
  });

  /* ── 2. Missing-items panel ───────────────────────────────────────────── */
  var ACTION = '[data-pcfg-continue],[data-pcfg-review-atc],[data-pcfg-add-to-cart]';
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(ACTION) : null;
    if (!btn) return;
    var panel = document.querySelector('[data-pcfg-missing]');
    if (!panel) return;
    var soft = btn.getAttribute('aria-disabled') === 'true';
    var cartBlocked = !panel.hidden && (btn.hasAttribute('data-pcfg-review-atc') || btn.hasAttribute('data-pcfg-add-to-cart'));
    if (!soft && !cartBlocked) return;
    setTimeout(function () {
      if (!panel.hidden) panel.setAttribute('data-fmr-alert', '');
    }, 0);
  }, true);

  function watchPanel() {
    var panel = document.querySelector('[data-pcfg-missing]');
    if (!panel || panel.__fmrWatched || !window.MutationObserver) return !!panel;
    panel.__fmrWatched = true;
    new MutationObserver(function () {
      if (panel.hidden) panel.removeAttribute('data-fmr-alert');
    }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
    return true;
  }

  function start() {
    syncReadmore();
    if (!watchPanel()) {
      var tries = 0;
      var iv = setInterval(function () { if (watchPanel() || ++tries > 40) clearInterval(iv); }, 500);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(syncReadmore, 150); });
})();
